import { Preset } from '@typings';
import { createAction } from 'typesafe-actions';

export const setPresets = createAction('presets/SET_PRESETS')<Preset.Map>();
